import { MakeCall } from './createMakeCall';

export default (makeCall: MakeCall) => (methodId: number) =>
  makeCall<undefined>('DELETE', `/api/v2/user/me/payout-method/${methodId}`);
